import { SVGProps } from 'react';

function IconUser({
  stroke = '#ffffff',
  ...restProps
}: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...restProps}
      fill="transparent"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M6.5 20.113a5.5 5.5 0 1 1 11 0M14.316 9.388c0 1.32-1.037 2.388-2.316 2.388s-2.316-1.069-2.316-2.388S10.721 7 12 7s2.316 1.07 2.316 2.388ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
      />
    </svg>
  );
}

export default IconUser;
